/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React, { PureComponent } from 'react';
import rpAdvertising from 'rp-advertising';
import initBookmakerRegPanel from 'rp-betting-special-offer';
import classNames from 'classnames';
import CardsContainer from './../Cards';
import NewsContainer from './../News';
import BookmakerRegPanelContainer from './../BookmakerRegPanel';
import RacedayLive from './../RacedayLive';
import Advertisement from './../Advertisement';
import Sidebar from './../Sidebar';
import {
    isContentHubPage,
    checkForRacedayLive,
    checkForRegPanel,
} from '../utils/contentHubHelper';

/**
 * Component that is used as a main entry point in application
 * It consists of:
 * <Cards />
 * <BookmakerRegPanel />
 * <RacedayLive />
 * <Sidebar />
 */
class App extends PureComponent {
    componentDidMount() {
        rpAdvertising();
        initBookmakerRegPanel();
    }

    render() {
        const isContentHub = isContentHubPage();
        const hasRacedayLive = checkForRacedayLive();
        const hasRegPanel = checkForRegPanel();

        return (
            <div className="ui-canvas ui-advertising__skinsWrp">
                <div className="ui-content">
                    <main>
                        <div
                            className={classNames(
                                'ui-mainContent',
                                isContentHub && 'rh-contentHub__container'
                            )}
                        >
                            {!isContentHub && <CardsContainer />}
                            {hasRegPanel && <BookmakerRegPanelContainer isMobile />}
                            <div className="rh-newsSection">
                                <NewsContainer />
                                {hasRacedayLive && <RacedayLive />}
                            </div>
                        </div>
                    </main>
                    <Advertisement position={2} />
                </div>
                <Sidebar />
                <Advertisement position={40} />
                <Advertisement position={41} />
            </div>
        );
    }
}

export { App as default };



// WEBPACK FOOTER //
// ./src/js/App/App.js